import { defineMessages } from 'react-intl';

export default defineMessages({
    stockPurchase: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.stock_purchase',
        defaultMessage: 'Inventory/stock purchase'
    },
    bridgingLoan: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.bridging_loan',
        defaultMessage: 'Bridging loan'
    },
    marketing: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.marketing',
        defaultMessage: 'Marketing'
    },
    equipmentPurchase: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.equipment_purchase',
        defaultMessage: 'Equipment/building purchase'
    },
    payBill: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.pay_bill',
        defaultMessage: 'Pay a due bill'
    },
    payStaff: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.pay_staff',
        defaultMessage: 'Pay staff'
    },
    refinancingDebt: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.refinancing_debt',
        defaultMessage: 'Refinancing debt'
    },
    other: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.rblTopUpReasons.other',
        defaultMessage: 'Other purpose'
    }
});
